import { config } from '../../../../config/config';
import { ConfigSchema } from '../../../../config/types';

/**
 * The address of the Music24 MCP server that a user gives to an AI assistant. It is on the public
 * music24-api origin: api.music24.com in production, api.musicpawa.com on staging, the local API
 * origin in development. There is one URL for every client.
 */
export const mcpUrlFor = (appConfig: Pick<ConfigSchema, 'music24ApiPublicURL'>): string =>
  `${appConfig.music24ApiPublicURL}mcp`;

export const MCP_URL = mcpUrlFor(config);
